import type { DashboardCampaignModel } from './dashboard.vm'

export type InactivityTargetCampaign = Pick<
	DashboardCampaignModel,
	'id' | 'status' | 'isArchived' | 'candidateCount' | 'candidatesPerDay' | 'updatedAt'
>

export type InactivityTarget =
	| { kind: 'campaign'; campaignId: string }
	| { kind: 'create_campaign' }

const DAY_MS = 24 * 60 * 60 * 1000

function hasOpenableCandidates(campaign: InactivityTargetCampaign): boolean {
	return !campaign.isArchived
		&& campaign.status !== 'draft'
		&& campaign.status !== 'publishing'
		&& (campaign.candidateCount ?? 0) > 0
}

function lastActiveDayIndex(campaign: InactivityTargetCampaign): number {
	return (campaign.candidatesPerDay ?? []).findLastIndex((count) => count > 0)
}

function mostRecentlyActive(campaigns: InactivityTargetCampaign[]): InactivityTargetCampaign | undefined {
	return campaigns.toSorted((first, second) =>
		lastActiveDayIndex(second) - lastActiveDayIndex(first)
		|| second.updatedAt.getTime() - first.updatedAt.getTime()
	)[0]
}

export function pickInactivityTarget(campaigns: InactivityTargetCampaign[]): InactivityTarget {
	const withCandidates = campaigns.filter(hasOpenableCandidates)
	const target = mostRecentlyActive(withCandidates.filter((campaign) => campaign.status === 'active'))
		?? withCandidates.toSorted((first, second) => second.updatedAt.getTime() - first.updatedAt.getTime())[0]

	return target ? { kind: 'campaign', campaignId: target.id } : { kind: 'create_campaign' }
}

export function inactivityDaysLeft(scheduledDeactivationAt: string, now: Date = new Date()): number {
	const deactivation = new Date(scheduledDeactivationAt)
	const deactivationDay = Date.UTC(
		deactivation.getUTCFullYear(),
		deactivation.getUTCMonth(),
		deactivation.getUTCDate(),
	)
	const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

	return Math.round((deactivationDay - today) / DAY_MS)
}
